import { API_ENDPOINTS } from './enums/endpoints.enum';

export interface IBaryPath {
  path: string;
  fragments: Array<string>;

  withId(id: number): string;
}

class BaryPath implements IBaryPath {
  path: string;
  fragments: Array<string> = [];

  constructor(path: string) {
    this.path = path;
    path.split('/').forEach(p => {
      if (p) {
        this.fragments.push(p);
      }
    });
  }

  get last(): string {
    return this.fragments[this.fragments.length - 1];
  }

  get root(): string {
    return this.fragments[0];
  }

  get lastTwo(): string {
    return this.fragments[this.fragments.length - 2] + '/' + this.fragments[this.fragments.length - 1];
  }

  get lastThree(): string {
    return this.fragments[this.fragments.length - 3] + '/' + this.fragments[this.fragments.length - 2] + '/' + this.fragments[this.fragments.length - 1];
  }

  withId(id?: number | string): string {
    return this.path.replace(':id', '' + id);
  }

  withCIdAndId(cid?: number | string, id?: number | string): string {
    return this.path.replace(':cid', '' + cid).replace(':id', '' + id);
  }

  withLogin(login?: string): string {
    return this.path.replace(':login', '' + login);
  }
}

export const PATHS = {
  HOME: new BaryPath('/'),
  FAQ: new BaryPath('/faq'),
  CGV: new BaryPath('/cgv'),
  CGU: new BaryPath('/cgu'),
  LEGAL_MENTION: new BaryPath('/legal-notices'),
  NOT_FOUND: new BaryPath('/404'),
  ACCESS_DENIED: new BaryPath('accessdenied'),
  LOGIN: new BaryPath('/login'),

  ADMIN: new BaryPath('/admin'),
  ADMIN_TOOLS: new BaryPath('/admin/tools'),
  ADMIN_USER_MANAGEMENT: new BaryPath('/admin/user-management'),
  ADMIN_USER_MANAGEMENT_LOGIN_VIEW: new BaryPath('/admin/user-management/:login/view'),
  ADMIN_USER_MANAGEMENT_LOGIN_CONTROL: new BaryPath('/admin/user-management/:api/authenticate'),
  ADMIN_USER_MANAGEMENT_LOGIN_EDIT: new BaryPath('/admin/user-management/:login/edit'),
  ADMIN_MODERATORS_LIST: new BaryPath('/admin/moderators'),
  ADMIN_USER_MANAGEMENT_NEW: new BaryPath('/admin/user-management/new'),
  ADMIN_MODERATOR_MANAGEMENT: new BaryPath('/admin/moderator-management'),
  ADMIN_IMPERSONATE_MANAGEMENT: new BaryPath('/admin/impersonate-management'),
  ADMIN_MODERATOR_MANAGEMENT_NEW: new BaryPath('/admin/moderator-management/new'),
  ADMIN_MODERATOR_MANAGEMENT_ID_EDIT: new BaryPath('/admin/moderator-management/:id/edit'),
  ADMIN_TRANSPORTER_MANAGEMENT: new BaryPath('/admin/transporter-management'),
  ADMIN_TRANSPORTER_MANAGEMENT_DATA: new BaryPath('/admin/transporter-management/data'),
  ADMIN_TRANSPORTER_MANAGEMENT_NEW: new BaryPath('/admin/transporter-management/new'),
  ADMIN_TRANSPORTER_MANAGEMENT_IMPORT: new BaryPath('/admin/transporter-management/import'),
  ADMIN_TRANSPORTER_MANAGEMENT_ID: new BaryPath('/admin/transporter-management/:id'),
  ADMIN_TRANSPORTER_MANAGEMENT_ID_EDIT: new BaryPath('/admin/transporter-management/:id/edit'),
  ADMIN_TRANSPORTER_MANAGEMENT_ID_EXPORT: new BaryPath('/admin/transporter-management/:id/export'),
  ADMIN_TRANSPORTER_MANAGEMENT_ID_CONFIGS: new BaryPath('/admin/transporter-management/:id/configs'),
  ADMIN_TRANSPORTER_MANAGEMENT_ID_DESTINATIONS: new BaryPath('/admin/transporter-management/:id/destinations'),
  ADMIN_TRANSPORTER_MANAGEMENT_ID_PRICING_CONFIGURATION: new BaryPath('/admin/transporter-management/:id/pricing-configuration'),
  ADMIN_TRANSPORTER_MANAGEMENT_CONFIGURATIONS: new BaryPath('/admin/transporter-management/:id/configurations'),
  ADMIN_TRANSPORTER_MANAGEMENT_DASHBOARD: new BaryPath('/admin/transporter-management/dashboard'),
  ADMIN_METRICS: new BaryPath('/admin/metrics'),
  ADMIN_HEALTH: new BaryPath('/admin/health'),
  ADMIN_CONFIGURATION: new BaryPath('/admin/configuration'),
  ADMIN_LOGS: new BaryPath('/admin/logs'),
  ADMIN_DOCS: new BaryPath('/admin/docs'),
  ADMIN_NEW_SHOP: new BaryPath('/admin/new-shop'),

  MIDDLE: new BaryPath('/middle'),
  MIDDLE_CUSTOMERS: new BaryPath('/middle/customers'),
  MIDDLE_VALIDATED_CUSTOMERS: new BaryPath('/middle/customers/validated'),
  MIDDLE_NEW_CUSTOMERS: new BaryPath('/middle/customers/new'),
  MIDDLE_CUSTOMER_ID: new BaryPath('/middle/customer/:id'),
  MIDDLE_CUSTOMER_ID_DATA: new BaryPath('/middle/customer/:id/data'),
  MIDDLE_CUSTOMER_ID_STATISTICS: new BaryPath('/middle/customer/:id/statistics'),
  MIDDLE_CUSTOMER_ID_PRICING: new BaryPath('/middle/customer/:id/pricing'),
  MIDDLE_CUSTOMER_ID_TRANSPORTS: new BaryPath('/middle/customer/:id/transports'),
  MIDDLE_CUSTOMER_ID_TRANSPORT_ID: new BaryPath('/middle/customer/:id/transport/:id'),
  MIDDLE_CUSTOMER_ID_BILLS: new BaryPath('/middle/customer/:id/bills'),
  MIDDLE_CUSTOMER_ID_BILLS_BILLS: new BaryPath('/middle/customer/:id/bills/bills'),
  MIDDLE_CUSTOMER_ID_BILLS_REFUNDS: new BaryPath('/middle/customer/:id/bills/refunds'),
  MIDDLE_TRANSPORTS: new BaryPath('/middle/transports'),
  MIDDLE_TRANSPORT_ID: new BaryPath('/middle/transport/:id'),
  MIDDLE_TRANSPORT_ID_UPDATE: new BaryPath('/middle/transport/:id/update'),
  MIDDLE_QUOTATIONS: new BaryPath('/middle/quotations'),
  MIDDLE_QUOTATIONS_NEW: new BaryPath('/middle/quotations/new'),
  MIDDLE_QUOTATIONS_ONGOING: new BaryPath('/middle/quotations/ongoing'),
  MIDDLE_QUOTATIONS_OLD: new BaryPath('/middle/quotations/old'),
  MIDDLE_BILLS: new BaryPath('/middle/bills'),
  MIDDLE_BILLS_BILLS: new BaryPath('/middle/bills/bills'),
  MIDDLE_BILLS_REFUNDS: new BaryPath('/middle/bills/refunds'),
  MIDDLE_COMMERCIALS: new BaryPath('/middle/commercials'),
  MIDDLE_COMMERCIAL: new BaryPath('/middle/commercial'),
  MIDDLE_SERVICE: new BaryPath('/middle/service'),
  MIDDLE_COMMERCIAL_NEW: new BaryPath('/middle/commercial/new'),
  MIDDLE_COMMERCIAL_ID_EDIT: new BaryPath('/middle/commercial/:id/edit'),
  MIDDLE_COMMERCIAL_SERVICE_NEW: new BaryPath('/middle/service/new'),
  MIDDLE_COMMERCIAL_SERVICE_ID_EDIT: new BaryPath('/middle/service/:id/edit'),
  MIDDLE_UPLOAD_PRICING: new BaryPath('/middle/upload-pricing'),
  MIDDLE_UPLOAD_ACCEPTANCE: new BaryPath('/middle/upload-acceptance'),
  MIDDLE_UPLOAD_DIRECTIONAL_CODE: new BaryPath('/middle/upload-directional-code'),
  MIDDLE_TRANSPORT_PLAN_ACCEPTANCE: new BaryPath('/middle/transport-plan/acceptance'),
  MIDDLE_TRANSPORTER_MAILS: new BaryPath('/middle/transporter-mails'),
  MIDDLE_HOMEPAGE: new BaryPath('/middle/homepage'),
  MIDDLE_TRANSPORTER: new BaryPath('/middle/transporter'),
  MIDDLE_TRANSPORTER_EDIT: new BaryPath('/middle/transporter/edit'),
  MIDDLE_TRANSPORTER_STATISTICS: new BaryPath('/middle/transporter-statistics'),
  MIDDLE_TRANSPORTER_DASHBOARD: new BaryPath('/middle/dashboard'),
  MIDDLE_TRANSPORTER_ANALYTICS: new BaryPath('/middle/analytics'),
  MIDDLE_TRANSPORTER_ANALYTICS_E_COMMERCE: new BaryPath('/middle/analytics/e-commerce'),
  MIDDLE_TRANSPORTER_ANALYTICS_CUSTOMERS: new BaryPath('/middle/analytics/customers'),
  MIDDLE_TRANSPORTER_ANALYTICS_CUSTOMERS_DETAILS: new BaryPath('/middle/analytics/customers/details'),
  MIDDLE_TRANSPORTER_ANALYTICS_CUSTOMERS_COMMITMENT: new BaryPath('/middle/analytics/customers/engagement'),
  MIDDLE_TRANSPORTER_ANALYTICS_CUSTOMERS_KNOWLEDGE: new BaryPath('/middle/analytics/customers/connaissance'),
  MIDDLE_TRANSPORTER_ANALYTICS_TRANSACTIONS_AND_PAYMENTS: new BaryPath('/middle/analytics/transactions-and-payments'),
  MIDDLE_TRANSPORTER_ANALYTICS_PROFITABILITY: new BaryPath('/middle/analytics/profitability'),
  MIDDLE_TRANSPORTER_ANALYTICS_OPERATIONAL_MONITORING: new BaryPath('/middle/analytics/operational-monitoring'),
  MIDDLE_CUSTOMER_STATISTICS_ID: new BaryPath('/middle/customer-statistics/:id'),
  MIDDLE_COMMERCIAL_STATISTICS: new BaryPath('/middle/commercial-statistics'),
  MIDDLE_COMMERCIAL_STATISTICS_ID: new BaryPath('/middle/commercial-statistics/:id'),
  MIDDLE_TRANSPORT_PLAN: new BaryPath('/middle/transport-plan'),
  MIDDLE_OFFERS: new BaryPath('/middle/offers'),
  MIDDLE_OFFER: new BaryPath('/middle/offer'),
  MIDDLE_OFFER_ID_EDIT: new BaryPath('/middle/offer/:id/edit'),
  MIDDLE_INSURANCE_ITEM_CATEGORIES: new BaryPath('/middle/insurance-item-categories'),
  MIDDLE_VEHICLES: new BaryPath('/middle/vehicles'),
  MIDDLE_INSURANCE: new BaryPath('/middle/insurance'),
  MIDDLE_RESOURCES: new BaryPath('/middle/resources'),
  MIDDLE_UNVALIDATED_BASKETS: new BaryPath('/middle/unvalidated-baskets'),

  // USER
  USER: new BaryPath('/user'),
  USER_MY_ACCOUNT: new BaryPath('/user/my-account'),
  USER_MY_DASHBOARD: new BaryPath('/user/my-dashboard'),
  USER_MY_TRANSPORTS: new BaryPath('/user/my-transports'),
  USER_MY_TRANSPORTS_TRANSPORT_ID: new BaryPath('/user/my-transports/transport/:id'),
  USER_MY_BILLS: new BaryPath('/user/my-bills'),
  USER_MY_BILLS_BILLS: new BaryPath('/user/my-bills/bills'),
  USER_MY_BILLS_REFUNDS: new BaryPath('/user/my-bills/refunds'),
  USER_MY_CONTACTS: new BaryPath('/user/my-contacts'),
  USER_MY_REGISTERED_ADDRESSES: new BaryPath('/user/my-registered-addresses'),
  USER_MY_REGISTERED_ADDRESSES_PICKUP: new BaryPath('/user/my-registered-addresses/pickup'),
  USER_MY_REGISTERED_ADDRESSES_DELIVERY: new BaryPath('/user/my-registered-addresses/delivery'),
  USER_MY_QUOTATION: new BaryPath('/user/my-quotations'),
  USER_MY_QUOTATION_NEW: new BaryPath('/user/my-quotations/new'),
  USER_MY_QUOTATION_ONGOING: new BaryPath('/user/my-quotations/ongoing'),
  USER_MY_QUOTATION_OLD: new BaryPath('/user/my-quotations/old'),
  USER_MY_SETTINGS: new BaryPath('/user/my-settings'),

  // payment
  PAYMENT: new BaryPath('/payment'),
  PAYMENT_CONFIRMATION: new BaryPath('/payment/confirmation'),
  ERROR_PAYMENT_CONFIRMATION: new BaryPath('/payment/error-confirmation'),

  // ORDER
  ORDER: new BaryPath('/order'),
  ORDER_BASKET: new BaryPath('/order/basket'),
  ORDER_CONFIRMATION: new BaryPath('/order/confirmation'),
  PAYZEN_RETURN: new BaryPath('/payzen/return'),

  // ACCOUNT
  ACCOUNT: new BaryPath('/account'),
  ACCOUNT_ACTIVATE: new BaryPath('/account/activate'),
  ACCOUNT_CONFIRMATION: new BaryPath('/account/confirmation'),
  ACCOUNT_ADD_TRANSPORT_ACCOUNT: new BaryPath('/account/add-transporter-account'),
  ACCOUNT_RESET_REQUEST: new BaryPath('/account/reset/request'),
  ACCOUNT_RESET_FINISH: new BaryPath('/account/reset/finish'),
  ACCOUNT_SETTINGS: new BaryPath('/account/settings'),
  ACCOUNT_REGISTER: new BaryPath('/account/register'),
  ACCOUNT_REGISTER_COMPANY: new BaryPath('/account/register/company'),
  ACCOUNT_REGISTER_USER: new BaryPath('/account/register/user'),
  ACCOUNT_REGISTER_ASSOCIATION: new BaryPath('/account/register/association'),
  ACCOUNT_REGISTER_VALIDATE: new BaryPath('/account/register/validate'),
  ACCOUNT_COMMITMENT: new BaryPath('/account/commitment'),

  // QUOTATION
  ESTIMATE: new BaryPath('/estimate'),
  ESTIMATE_ITEMS: new BaryPath('/estimate/items'),
  ESTIMATE_PICKUP: new BaryPath('/estimate/pickup'),
  ESTIMATE_DELIVERY: new BaryPath('/estimate/delivery'),
  ESTIMATE_EXTRA_CONDITION: new BaryPath('/estimate/extra-condition'),

  // DOWNLOADS
  API_MY_BILLS_PDF_DOWNLOAD: new BaryPath('/api' + API_ENDPOINTS.BILLS + '/pdf/:id'),
  API_MY_BILLS_PDF_VIEW: new BaryPath(API_ENDPOINTS.BILLS + '/browserPdf/:id'),
  API_STICKER_DOWNLOAD: new BaryPath('/api/open' + API_ENDPOINTS.DOCUMENT + '/download/STICKER/:id'),
  API_STICKER_VIEW: new BaryPath('/api/open' + API_ENDPOINTS.DOCUMENT + '/browser/STICKER/:id'),
  API_MIDDLE_DOWNLOAD_EMPTY_ACCEPTANCE: new BaryPath(API_ENDPOINTS.ACCEPTANCES + '/empty'),
  API_MIDDLE_DOWNLOAD_ACCEPTANCE: new BaryPath('/api' + API_ENDPOINTS.ACCEPTANCES + '/transporter/file'),
  API_MIDDLE_DOWNLOAD_ACCEPTANCE_WITH_OFFER: new BaryPath('/api' + API_ENDPOINTS.ACCEPTANCES + '/transporter/file/offer/:id'),
  API_MIDDLE_DOWNLOAD_EMPTY_CUTOFF: new BaryPath(API_ENDPOINTS.CUT_OFFS + '/empty'),
  API_MIDDLE_DOWNLOAD_CUTOFF: new BaryPath('/api' + API_ENDPOINTS.CUT_OFFS + '/transporter/file'),
  API_MIDDLE_DOWNLOAD_CUTOFF_WITH_OFFER: new BaryPath('/api' + API_ENDPOINTS.CUT_OFFS + '/transporter/file/offer/:id'),
  API_MIDDLE_DOWNLOAD_CUSTOMER_PRICING: new BaryPath('/api' + API_ENDPOINTS.PRICING + '/file/offer/:cid/customer/:id/file'),
  API_MIDDLE_DOWNLOAD_PRICING: new BaryPath('/api' + API_ENDPOINTS.PRICING + '/file/offer/:id'),
  API_MIDDLE_DOWNLOAD_EMPTY_PRICING: new BaryPath('/api' + API_ENDPOINTS.PRICING + '/file/offer/:id/empty'),
  API_MIDDLE_DOWNLOAD_EMPTY_FILE: new BaryPath('/file/:id/empty'),

  // SECURED
  API_MIDDLE_DOWNLOAD_EMPTY_SPECIAL_PLACE: new BaryPath(API_ENDPOINTS.SPECIAL_PLACE + '/file/empty'),
  API_MIDDLE_DOWNLOAD_SPECIAL_PLACE: new BaryPath(API_ENDPOINTS.SPECIAL_PLACE + '/file/:id'),

  // ROBOT
  HI_ROBOT: new BaryPath('/hi-robot'),

  // BROWSE PDF
  BROWSE_PDF: new BaryPath('/browse-pdf/:filename'),
};
